import styled from 'styled-components'

export const IconWrapper = styled.div`
  margin-top: 0.1375rem;
  vertical-align: middle;
  display: inline-block;
`
